import settings from '@/settings';
import { AdditionalInfoProps } from './types';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const isCaStore = settings.store === 'reebelo-ca';
const isAuStore = settings.store === 'reebelo-au';

const AdditionalInfo = ({ showModal }: AdditionalInfoProps) => (
  <>
    {isCaStore && (
      <div className="mt-3 text-gray-700/60">
        <a
          target="_blank"
          href={getEdgeUrl('files/sqt/PDS-CA.pdf')}
          className="underline underline-offset-2 hover:text-gray-700"
        >
          Product Summary
        </a>{' '}
        -{' '}
        <a
          target="_blank"
          href={getEdgeUrl('files/sqt/PDS-FRCA.pdf')}
          className="underline underline-offset-2 hover:text-gray-700"
        >
          Sommaire du Produit
        </a>
      </div>
    )}
    {isAuStore && (
      <button
        type="button"
        className="mt-3 text-gray-700 underline"
        onClick={() => showModal()}
      >
        More info
      </button>
    )}
  </>
);

export default AdditionalInfo;
